import { AmbientGlow, CheckMark, XMark } from "./_shared";

// Ported from Claude Design handoff (sections-rest: BeforeAfter).

const BEFORE_ITEMS = [
  "Zero visibilidade de segurança",
  "Descoberta de ameaças é acidental",
  "Sem compliance evidence para clientes",
  "Prêmios de seguro mais caros",
  "Risco de multa LGPD não quantificado",
  "Nenhum relatório para investidores",
];

const AFTER_ITEMS = [
  "Visibilidade completa 24/7",
  "Alertas automáticos para ameaças",
  "Relatórios executivos LGPD-compliant",
  "Prêmios de seguro mais baratos",
  "Evidence de compliance reduz risco de multa",
  "Relatórios profissionais para diligência",
];

export function BeforeAfter() {
  return (
    <section
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tr-bl" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontFamily: "var(--cy-fs-sans)",
            fontSize: "clamp(36px, 4.5vw, 52px)",
            lineHeight: 1.05,
            letterSpacing: "-0.03em",
            fontWeight: 500,
            margin: "0 0 64px",
            color: "var(--cy-ink-100)",
            textWrap: "balance",
          }}
        >
          O antes e o depois de quem monitora
        </h2>

        <div
          className="cy-grid-2"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 24,
          }}
        >
          {/* Before */}
          <div
            style={{
              padding: "32px 32px 36px",
              border: "1px solid rgba(255,77,77,0.2)",
              background: "linear-gradient(180deg, rgba(255,77,77,0.05), transparent)",
            }}
          >
            <div
              className="cy-tape"
              style={{ color: "var(--cy-crit)", marginBottom: 24 }}
            >
              ● SEM CYPHRON
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              {BEFORE_ITEMS.map((i) => (
                <li
                  key={i}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "20px 1fr",
                    gap: 12,
                    alignItems: "start",
                    fontSize: 15,
                    color: "var(--cy-ink-80)",
                  }}
                >
                  <XMark size={16} color="var(--cy-crit)" />
                  <span>{i}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* After */}
          <div
            style={{
              padding: "32px 32px 36px",
              border: "1px solid rgba(132,255,0,0.25)",
              background: "linear-gradient(180deg, rgba(132,255,0,0.06), transparent)",
            }}
          >
            <div
              className="cy-tape"
              style={{ color: "var(--cy-accent)", marginBottom: 24 }}
            >
              ● COM CYPHRON
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              {AFTER_ITEMS.map((i) => (
                <li
                  key={i}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "20px 1fr",
                    gap: 12,
                    alignItems: "start",
                    fontSize: 15,
                    color: "var(--cy-ink-100)",
                  }}
                >
                  <CheckMark size={16} />
                  <span>{i}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          style={{
            marginTop: 32,
            textAlign: "center",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              padding: "18px 28px",
              border: "1px solid rgba(132,255,0,0.28)",
              background: "rgba(132,255,0,0.06)",
              borderRadius: 999,
              fontSize: 15,
              color: "var(--cy-ink-100)",
            }}
          >
            <span>
              <strong style={{ fontWeight: 500 }}>
                Uma detecção precoce que evita uma brecha
              </strong>
              <span style={{ color: "var(--cy-ink-60)" }}>
                {" "}= 40x o valor investido no Cyphron
              </span>
            </span>
          </span>
        </div>
      </div>
    </section>
  );
}
